import * as React from 'react'

export interface LearningPathContextProps {
  active: number
  activeHover: number
  playVideo: string
  setActive: (active: number) => void
  setActiveHover: (activeHover: number) => void
  setPlayVideo: (playVideo: string) => void
}

const { Provider, Consumer } = React.createContext<LearningPathContextProps>({
  active: 0,
  activeHover: 0,
  playVideo: '',
  setActive: (active: number) => active,
  setActiveHover: (activeHover: number) => activeHover,
  setPlayVideo: (playVideo: string) => playVideo,
})

export { Provider, Consumer }
